import React from "react";

export const ExportIcon = ({ marginRight }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginRight: marginRight ? marginRight : 0 }}
    >
      <g id="Iconsax/Linear/exportcurve">
        <path
          id="Vector"
          d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91M12 15V3.62M15.35 5.85L12 2.5L8.64998 5.85"
          stroke="#FF6D1D"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};
